import { SPOILER_TYPE, POLL_TYPE, TIPTAP_POLL_TYPE, } from 'wix-rich-content-common';
export const getAbsoluteUrl = (url) => url.substring(0, 5).includes('http') ? url : 'http://' + url;
export const hasPlugin = (pluginType, plugins) => !!plugins?.some(plugin => plugin.type === pluginType);
export const getPluginConfig = (pluginType, plugins) => plugins?.find(plugin => plugin.type === pluginType)?.config || {};
export const extractPluginsConfig = (plugins, helpers) => {
    let mergedConfig = {};
    plugins?.forEach(plugin => {
        const { type, config } = plugin;
        if (Object.keys(config).length !== 0) {
            mergedConfig = { ...mergedConfig, [type]: config };
        }
        if (type === SPOILER_TYPE && helpers) {
            mergedConfig[type].onViewerAction = helpers.onViewerAction;
        }
    });
    return { config: mergedConfig };
};
export const hasPollsPluginInContent = (content) => {
    if (!content) {
        return false;
    }
    const nodes = content.nodes;
    return nodes?.some(node => [POLL_TYPE, TIPTAP_POLL_TYPE].includes(node.type));
};
//# sourceMappingURL=utils.js.map